/* eslint-disable compat/compat */
/**
 * Utilities
 */

import debounce from "lodash/debounce";

const isDev = (process.env.NODE_ENV !== 'production');

const mapStyles = [
    {
        featureType:'transit',
        elementType:'labels.icon',
        stylers:[{'visibility':'off'}]
    },
    {
        featureType:'poi',
        elementType:'geometry.fill',
        stylers:[{hue:'#2472EC'},{saturation:-77},{lightness:13}]
    },
    {
        featureType:'poi',
        elementType:'labels.text',
        stylers:[{visibility:'off'}]
    },
    {
        featureType:'poi',
        elementType:'labels.icon',
        stylers:[{visibility:'off'}]
    },
    {
        featureType:'all',
        elementType:'all',
        stylers:[{hue:'#2472EC'},{saturation:-49}]
    }
];

const loadGoogleMaps = () =>
    new Promise((resolve, reject) => {
        if (window.loadedMaps === undefined) {
            const googleKey = window.googleMapsApiKey;
            const src = `https://maps.googleapis.com/maps/api/js?key=${googleKey}`;
            const script = document.createElement('script');
            script.type = 'text/javascript';
            script.src = src;
            script.onload = () => resolve(true);
            document.body.appendChild(script);
            window.loadedMaps = true;
            return;
        }

        // Delay loading of 2n+ maps to avoid duplicate script errors.
        // Unsure of a better way to do this.
        if (window.loadedMaps === true) {
            setTimeout(() => resolve(true), 3000);
        }
    });

export {
    debounce,
	isDev,
	mapStyles,
	loadGoogleMaps
};
